import { v4 as uuidv4 } from "uuid";
export class TagGridViewModel {
    constructor() {
        this.id = uuidv4();
        this.name = "";
        this.description = "";
        this.color = "";
        this.teamId = uuidv4();
        this.teamName = "";
    }
}
export default class TagGridView extends TagGridViewModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
